export default __webpack_public_path__ + "static/media/testify9.10eba665.png";